import "./index.js"; import "./persist_scroll.coffee"; import "./turbolinks.coffee"; import "./turbolinks.scss"
